let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("c6h2T")).then(() => parcelRequire('4wUVQ'));